import COLOR from 'utils/Color';

const BOOL = {
  YES: [true, 'Có', COLOR.APPROVE],
  NO: [false, 'Không', COLOR.REJECT],
};
export default BOOL;
